import { computed, type ComputedRef, type Ref } from 'vue'
import { useI18n } from 'vue-i18n'

import type { RingBuilderStoneTypes } from '@/domain/product/ring/ring-builder'
import { useTotalSaleAmount } from '@/domain/stone/price'
import { useMoneyFormatter } from '@/plugins/money-formatter.ts'
import type { MoneyFragment } from '@/graphql/api'

interface StonePrice {
    totalSaleAmount: ComputedRef<MoneyFragment>
    price: ComputedRef<string>
}

export function useStonePrice(
    stone: Ref<RingBuilderStoneTypes | null | undefined>
): StonePrice {
    const { t } = useI18n()
    const { totalSaleAmount } = useTotalSaleAmount(stone)
    const moneyFormatter = useMoneyFormatter()

    const price = computed(() =>
        totalSaleAmount.value.amount
            ? moneyFormatter(totalSaleAmount.value)
            : t('diamond_search.enquire_for_price')
    )

    return {
        totalSaleAmount,
        price,
    }
}
